<script setup lang="js">
import { ref, onMounted, computed } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useAutonodeStore } from '@/stores/autonode.store';
import { useProjectStore } from '@/stores/project.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';
import { useNodeStore } from '@/stores/node.store';
import _ from 'lodash';
import Multiselect from 'vue-multiselect';

const autonodeStore = useAutonodeStore();
const projectStore = useProjectStore();
const nodeStore = useNodeStore();
const { custom_variables, directionOrgs, selectedDirectionOrgIndex } = storeToRefs(autonodeStore);
const { project } = storeToRefs(projectStore);
const { bpNode } = storeToRefs(nodeStore);
const { closeModal } = useModal();
const projectId = useRouteParams('projectId');

const directionOrgVariable = ref('');
const directionId = ref(null);
const searchQuery = ref('');

const directionOptions = computed(() => bpNode.value.child_directions?.map(d => d.id) || []);

function getTitle(id) {
  return bpNode.value.child_directions?.find(d => d.id === id)?.next_bp_node?.current?.node?.name;
}

function createDirectionOrg() {
  if (selectedDirectionOrgIndex.value in directionOrgs.value) {
    directionOrgs.value.splice(selectedDirectionOrgIndex.value, 1);
  }

  directionOrgs.value.push({
    direction_id: directionId.value,
    variable: directionOrgVariable.value
  })

  closeModal();
}

function filteredOptions(list) {
  const query = searchQuery.value?.toLowerCase() || '';
  return list.filter(item =>
    item.title?.toLowerCase().includes(query)
  );
}

onMounted(() => {
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
  if (selectedDirectionOrgIndex.value in directionOrgs.value) {
    const directionOrg = directionOrgs.value[selectedDirectionOrgIndex.value];
    directionOrgVariable.value = directionOrg.variable;
    directionId.value = directionOrg.direction_id;
  }
});
</script>

<template>
  <ModalTemplateSide @submit="createDirectionOrg">
    <template v-slot:title>Добавить организацию на направление</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Направление</label>
        <Multiselect v-model="directionId" :options="directionOptions" placeholder="Выбрать..." :multiple="false"
          :custom-label="getTitle" class="multiselect-style" />
      </div>
      <div class="mt-3">
        <label class="form-label">Переменная</label>
        <input type="text" v-model="searchQuery" placeholder="Поиск..." class="form-control mb-2" />
        <select v-model="directionOrgVariable" class="form-select">
          <option v-for="variable in filteredOptions(custom_variables)" :key="variable.name" :value="variable.name">
            {{ variable.title }}
          </option>
        </select>
      </div>
    </template>
    <template v-slot:submit>
      {{ selectedDirectionOrgIndex === null ? 'Добавить' : 'Изменить' }}
    </template>
  </ModalTemplateSide>
</template>
